import { PayloadAction } from "@reduxjs/toolkit";
import { FormError } from "app/containers/types";
import set from "lodash/set";
import { createSlice } from "utils/@reduxjs/toolkit";
import { ContactListItemType, UserState } from "../types";
const initialState = UserState;
export const ContactListSlice = createSlice({
  name: "contactListState",
  initialState,
  reducers: {
    editUser: (state) => {
      const index = state.list.items.findIndex(
        (item) => item.id == state.form.contact.id
      );
      state.list.items = [
        ...state.list.items.slice(0, index),
        {
          id: state.form.contact.id,
          contactName: state.form.contact.contactName.value,
          title: state.form.contact.title.value,
          email: state.form.contact.email.value,
          mobileNumber: state.form.contact.mobileNumber.value,
          action: "edit",
        },
        ...state.list.items.slice(index + 1),
      ];
    },
    removeUser: (state) => {
      const editUser: any = {};
      editUser.firstName = "";
      editUser.lastName = "";
      editUser.email = "";
      editUser.phoneNumber = "";
      editUser.creationDate = null;
      editUser.dateOfBirth = null;
    },
    create: (state) => {
      state.list.items = [
        {
          id: null,
          contactName: state.form.contact.contactName.value,
          title: state.form.contact.title.value,
          email: state.form.contact.email.value,
          mobileNumber: state.form.contact.mobileNumber.value,
          action: "new",
        },
        ...state.list.items,
      ];
      state.loading = true;
    },
    createSuccess: (state) => {
      state.loading = false;
      state.form.contact = initialState.form.contact;
    },
    getList: (state, action: PayloadAction<{ id: any }>) => {
      state.loading = true;
      state.query.page = 1;
    },
    getUserById: (state, action: PayloadAction<{ id: any }>) => {
      state.loading = true;
    },
    getListSuccess: (
      state,
      action: PayloadAction<{ items: []; links: any; meta: any }>
    ) => {
      const items = action.payload.items;
      state.list.items =
        action.payload.meta.currentPage === 1
          ? items
          : [...state.list.items, ...items];
      state.list.meta = action.payload.meta;
      state.loading = false;
    },
    setContactsForDuplicate: (
      state,
      action: PayloadAction<ContactListItemType[]>
    ) => {
      state.loading = false;
      state.list.items = action.payload.map((item) => ({
        id: null,
        contactName: item.contactName,
        title: item.title,
        email: item.email,
        mobileNumber: item.mobileNumber,
        action: "new",
      }));
      state.list.meta = initialState.list.meta;
    },
    getListComplete: (state) => {
      state.loading = false;
    },
    getNextPage: (state, action: PayloadAction<any>) => {
      state.query.page = state.list.meta.currentPage + 1;
      state.loading = true;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    update: (
      state,
      action: PayloadAction<{ id: any; callback: () => void }>
    ) => {
      state.error = "";
      state.loading = true;
    },
    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      if (action.payload.key == "id") {
        set(state.form.contact, `${action.payload.key}`, action.payload.value);
      } else {
        set(
          state.form.contact,
          `${action.payload.key}.value`,
          action.payload.value
        );
      }
      if (
        state.form.contact.contactName.value !== "" &&
        state.form.contact.email.value !== "" &&
        state.form.contact.mobileNumber.value !== "" &&
        state.form.contact.title.value !== ""
      ) {
        set(state.form.contact, `disable`, false);
      } else {
        set(state.form.contact, `disable`, true);
      }
    },
    updateSuccess(state, action: PayloadAction<ContactListItemType>) {
      state.loading = false;
    },
    updateFailed: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    delete: (state) => {
      state.error = "";
      state.loading = true;
    },
    deleteSuccess: (state) => {
      state.loading = false;
      state.error = "";
    },
    deleteContact: (state, action) => {
      const { id, idx } = action.payload;
      if (id) {
        for (let i = 0; i < state.list.items.length; i++) {
          const item = state.list.items[i];
          if (item.id === id) {
            state.list.items[i].action = "delete";
            break;
          }
        }
      } else {
        state.list.items = state.list.items.filter(
          (item, index) => index !== idx
        );
      }
    },
    deleteFailed: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetNewUserForm(state) {
      state.error = "";
      state.form = initialState.form;
      state.loading = false;
    },
    setFormErrors(
      state,
      action: PayloadAction<{
        key: string;
        errors: FormError[];
      }>
    ) {
      action.payload.errors.forEach((error) => {
        set(
          state.form,
          `${action.payload.key}.${error.name}.error`,
          error.error
        );
      });
    },
    getNextPageItems: (state, action: PayloadAction<any>) => {
      state.loading = true;
    },
    getNextPageItemsSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.list.items = state.list.items.concat(action.payload.items);
      state.list.meta.currentPage = action.payload.meta.currentPage;
      state.list.links = action.payload.links;
      state.query.page = action.payload.meta.currentPage;
    },
    setQuery: (state, action: PayloadAction<{ name: string; value: any }>) => {
      const { name, value } = action.payload;
      state.query.page = 1;
      state.list = initialState.list;
      set(state.query, name, value);
    },
    resetModule: (state) => {
      state.list.items = [];
    },
    handleBlock: (state, action: PayloadAction<string>) => {},
    handleBlockSuccess: (
      state,
      action: PayloadAction<ContactListItemType>
    ) => {},
  },
});
export const { reducer, actions, name: sliceKey } = ContactListSlice;
